// src/components/KendoLocalizationWrapper.tsx
import React, {useEffect, useState} from 'react';
import {IntlProvider, LocalizationProvider} from '@progress/kendo-react-intl';
import {useTranslation} from 'react-i18next';
import {loadKendoLocale} from "../../i18n/loadKendoLocale";


export const KendoLocalizationWrapper: React.FC<{ children: React.ReactNode }> = ({children}) => {
    const {i18n} = useTranslation();
    const [kendoLang, setKendoLang] = useState<string>("en");

    useEffect(() => {
        const locale = i18n.language;
        loadKendoLocale(locale).then((verifiedLang : string) => {
            setKendoLang(verifiedLang);
        });
    }, [i18n.language]);

    return <LocalizationProvider language={kendoLang}>
        <IntlProvider locale={kendoLang}>
            {children}
        </IntlProvider>
    </LocalizationProvider>;
};
